import { twMerge } from 'tailwind-merge';

import { MapIcon } from '../Icons/MapIcon';

interface IProps {
  innerClassName?: string;
}

export const StaticMapPlaceholder = ({ innerClassName = '' }: IProps) => {
  return (
    <div className="absolute size-full p-4 text-sea-foam sm:p-8">
      <div
        className={twMerge(
          `flex h-full w-full items-center justify-center rounded-lg bg-lake-fog`,
          innerClassName,
        )}
      >
        <div className="rounded-sm bg-disabled p-3">
          <MapIcon />
        </div>
      </div>
    </div>
  );
};
